import React from "react";
import { connect } from "react-redux";
import ReactModal from "react-modal";
import { withTranslation, Trans } from "react-i18next";

const NullView = () => (
  <div>
    <Trans>thisViewIsNotYetImplemented...</Trans>
  </div>
);

class ModalContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      loadedComponents: [],
      components: [],
      compiledComponent: (
        <div>
          <Trans>nothingToDisplay...</Trans>
        </div>
      )
    };
    this.closeModal = this.closeModal.bind(this);
  }

  addView = async (viewName, modalProps) => {
    // Don't load more than once.
    if (this.state.loadedComponents.includes(viewName)) {
      let indexTemplate = this.state.loadedComponents.indexOf(viewName);
      let componentTemplate = this.state.components[indexTemplate];
      this.setState({
        compiledComponent: (
          <div className="modal-content" key="viewName">
            <componentTemplate.default
              closeModal={this.closeModal}
              {...modalProps}
            />
          </div>
        )
      });
    } else {
      import(`../../App/${viewName}.js`)
        .then(Component => {
          this.setState({
            loadedComponents: this.state.loadedComponents.concat(viewName),
            components: this.state.components.concat(Component),
            compiledComponent: (
              <div className="modal-content" key="viewName">
                <Component.default
                  closeModal={this.closeModal}
                  {...modalProps}
                />
              </div>
            )
          });
        })
        .catch(error => {
          this.setState({
            loadedComponents: this.state.loadedComponents.concat(viewName),
            components: this.state.components.concat(<NullView key="test 12" />)
          });
        });
    }
  };

  handleShowTableChange = async (name, modalProps) => {
    await this.addView(name, modalProps);
  };

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {

      this.setState({
        modalIsOpen: this.props.modalProps.open,
        compiledComponent: (
          <div>
            <Trans>nothingToDisplay...</Trans>
          </div>
        )
      });
      this.props.template &&
        this.handleShowTableChange(this.props.template, this.props.modalProps);
    }
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  render() {
    const { compiledComponent } = this.state;
    return (
      <div>
        <ReactModal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Example Modal"
          ariaHideApp={false}
          overlayClassName="modal fade show"
          bodyOpenClassName="modal-open"
          className="modal-dialog modal-dialog-centered"
        >
          {compiledComponent}
        </ReactModal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state.modalPopup
});

export default connect(
  mapStateToProps,
  null
)(withTranslation()(ModalContainer));
